import { toast } from "sonner";

interface SwalOptions {
  title?: string;
  text?: string;
  html?: string;
  type?: "error" | "success" | "info" | "warning" | "question";
  icon?: "error" | "success" | "info" | "warning" | "question";
  showCancelButton?: boolean;
  showConfirmButton?: boolean;
  confirmButtonText?: string;
  cancelButtonText?: string;
  confirmButtonColor?: string;
  cancelButtonColor?: string;
  reverseButtons?: boolean;
  timer?: number;
  toast?: boolean;
  showCloseButton?: boolean;
  position?: string;
  width?: string | number;
  customClass?: any;
  preConfirm?: () => any | Promise<any>;
  inputValidator?: (value: string) => string | null | undefined;
  input?: string;
  inputPlaceholder?: string;
  imageUrl?: string;
  [key: string]: any;
}

interface SwalResult {
  value: any;
  isConfirmed: boolean;
  isDismissed: boolean;
  isDenied: boolean;
  dismiss?: string;
}

const fire = async (
  arg1?: SwalOptions | string,
  arg2?: string,
  arg3?: SwalOptions["type"]
): Promise<SwalResult> => {
  let opts: SwalOptions;
  if (typeof arg1 === "string") {
    opts = { title: arg1, text: arg2, type: arg3 };
  } else {
    opts = arg1 || {};
  }

  const kind = opts.icon || opts.type;
  const title = (opts.title || opts.text || opts.html || "").toString();
  const description =
    opts.title && (opts.text || opts.html)
      ? (opts.text || opts.html || "").toString()
      : undefined;

  if (opts.showCancelButton) {
    const confirmed = window.confirm(
      [opts.title, opts.text].filter(Boolean).join("\n\n") ||
        opts.html ||
        "Bestätigen?"
    );
    return {
      value: confirmed,
      isConfirmed: confirmed,
      isDismissed: !confirmed,
      isDenied: false,
      dismiss: confirmed ? undefined : "cancel",
    };
  }

  const fn =
    kind === "error"
      ? toast.error
      : kind === "success"
      ? toast.success
      : kind === "warning"
      ? toast.warning
      : kind === "info"
      ? toast.info
      : toast;

  fn(title, description ? { description } : undefined);

  return {
    value: true,
    isConfirmed: true,
    isDismissed: false,
    isDenied: false,
  };
};

const Swal = { fire };
export default Swal;
